export const AuthStrategy = {
	CUSTOM: 'CUSTOM',
	AUTH0: 'AUTH0',
	FRONTEGG: 'FRONTEGG',
	FRONTEGG_CUSTOM: 'FRONTEGG_CUSTOM',
} as const
